/**
 * 预览图片
 * 优先微信，不行再 viewerjs
 */

import wechat from 'weixin-js-sdk'
import { VIEWER_UPDATE, VIEWER_SHOW, VIEWER_HIDE } from '@/constants/pub_sub'
import eventBus from '@/event_bus'

function checkOneJsApi (jsApi) {
    return new Promise((resolve, reject) => {
        if (!eventBus.isWechatJSSDKReady) {
            reject(false)
        }

        wechat.checkJsApi({
            jsApiList: [jsApi],
            success: ({ checkResult }) => {
                if (checkResult[jsApi]) {
                    resolve(true)
                }
                reject(false)
            },
            fail: () => {
                reject(false)
            }
        })
    })
}

function previewImageByViewerjs (previewIndex) {
    // 因为 desktop 下，组件 mounted 已经 update 了
    if (!eventBus.isDesktop) {
        eventBus.$emit(VIEWER_UPDATE)
    }
    eventBus.$emit(VIEWER_SHOW, previewIndex)
}

// 获取当前预览img在所有img元素中的索引
function getCurrentImgIndex (img) {
    const msgBox = document.getElementsByClassName('message-list')[0]
    const imgList = Array.from(msgBox.querySelectorAll('img.viewer'))
    return imgList.indexOf(img) === -1 ? 0 : imgList.indexOf(img)
}

export default {
    methods: {
        async previewImage ($event, url) {
            const previewIndex = getCurrentImgIndex($event.currentTarget)
            if (!url) {
                url = this.url
            }
            console.log(previewIndex)
            try {
                if (await checkOneJsApi('previewImage')) {
                    wechat.previewImage({
                        current: url,
                        urls: [url],
                        success: () => {
                            // 避免微信和viewerjs同时打开
                            eventBus.$emit(VIEWER_HIDE)
                        },
                        fail: () => {
                            previewImageByViewerjs(previewIndex)
                        }
                    })
                }
            } catch (err) {
                // eslint-disable-next-line
                console.error(err)
                previewImageByViewerjs(previewIndex)
            }
        }
    }
}
